import React, { forwardRef } from 'react';

import type { TooltipProps } from '@mui/material';
import { Avatar, Typography } from '@mui/material';
import clsx from 'clsx';
import { AlineTooltip } from 'src/components';
import type { Apollo } from 'src/gql/generated';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  avatar: {
    backgroundColor: theme.appColors.partyColor,
    borderRadius: 8,
    height: 32,
    width: 32,
  },
  circle: {
    alignItems: 'center',
    backgroundColor: theme.appColors.buttonHover,
    borderRadius: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    height: 24,
    justifyContent: 'center',
    width: 24,
  },
  text: {
    color: theme.palette.common.white,
  },
}));

interface FakeParty {
  __typename: 'FakeParty';
  name: string;
}

interface PartyAvatarProps extends React.HTMLAttributes<HTMLElement> {
  party: Partial<Pick<Apollo.Party, 'id' | 'name' | '__typename'>> | FakeParty;
  tooltipProps?: Partial<TooltipProps>;
  withTooltip?: boolean;
}

export const PartyAvatar = forwardRef(function PartyAvatar(
  props: PartyAvatarProps,
  ref: React.Ref<HTMLDivElement>
): JSX.Element {
  const { classes } = useStyles();
  const partyName = props.party.name || 'Untitled';
  const {
    className,
    tooltipProps: { arrow = true, placement = 'top', title = partyName, ...restTooltipProps } = {},
    withTooltip = false,
  } = props;

  return (
    <AlineTooltip
      ref={ref}
      arrow={arrow}
      placement={placement}
      title={withTooltip ? title : ''}
      {...restTooltipProps}
    >
      <Avatar className={clsx(classes.avatar, className)}>
        <div className={classes.circle}>
          <Typography className={classes.text}>{partyName.charAt(0).toUpperCase()}</Typography>
        </div>
      </Avatar>
    </AlineTooltip>
  );
});
